<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      :col="3"
      :columns="tableColumns"
      :queryParams="queryParams"
      :searchOptions="tableSearchOptions"
      :requestPromise="loadData?loadData:loadDataList"
    >
      <template v-slot:proIsShield="{text}"> {{text==1?'已屏蔽':'正常'}}</template>
      <template v-slot:proJoinType="{text}"> {{getTypeName(text,joinTypeList)}}</template>
      <template v-slot:proCatalogId="{text}">{{getTypeName(text,productCategoryList)}}</template>
      <template v-slot:action="{record}" >
        <!--编辑 员工 认证设置 审批设置 组织架构 禁用-->
        <a-space>
           <a @click="onSwitchStatus(record)">{{ record.proIsShield == 1 ? '解除屏蔽' : '屏蔽' }}</a>
           <a @click="onUpdateEvent(record)">手动更新</a>
           <a @click="onTaskEvent(record)">定时任务</a>
        </a-space>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ZwyMiXins from '@/views/resource/zwy/mixins/ZwyMiXins'

export default {
  name: 'ProductUpdateComponent',
  mixins:[SearchMixins,ZwyMiXins],
  props:{
    proJoinType:{
      type:String,
      default:''
    },
    columns:{
      type:Array,
      default:()=>[]
    },
    searchOptions:{
      type:Array,
      default:()=>[]
    },
    loadData:{
      type:Function,
      default:undefined
    },
    triggerScheduleUrl:{
      type:String,
      default:'zwy/combo/triggerSchedule'
    },
    manualUpdateUrl:{
      type:String,
      default:'zwy/combo/manualUpdate'
    },
    // 首列/搜索项文案（自我游日历房传「酒店ID」默认是自我游ID）
    idLabel:{
      type:String,
      default:'自我游ID'
    },
    // 「商品信息」列文案（自我游日历房传「酒店名称」默认是商品信息）
    nameLabel:{
      type:String,
      default:'商品信息'
    },
    // 「商品名称」搜索项文案（自我游日历房传「酒店名称」）
    searchNameLabel:{
      type:String,
      default:'商品名称'
    },
    // 是否显示「价格计划ID/名称」列（rateplanOtherId/rateplanName，日历房专用）
    showRateplanOtherId:{
      type:Boolean,
      default:false
    }
  },
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {
      },
      localSearchOptions: [
        {
          name: '商品ID',
          key: 'proId',
          type: 'input',
          placeholder: '请输入商品ID'
        },
        {
          name: this.searchNameLabel,
          key: 'proName',
          type: 'input',
          placeholder: `请输入${this.searchNameLabel}`
        },
        {
          name: '商品分类',
          key: 'proCatalogId',
          type: 'select',
          placeholder: '请选择',
          selectOptions: []
        },
        // {
        //   name: '自我游类目',
        //   type: 'select',
        //   key: 'proJoinType',
        //   placeholder: '请选择',
        //   selectOptions: []
        // },
        {
          name: '更新日期',
          key: 'startDate,endDate',
          type: 'rangePicker',
        },
        // 日历房专用：按价格计划ID搜索
        ...(this.showRateplanOtherId ? [{
          name: '价格计划ID',
          key: 'rateplanOtherId',
          type: 'input',
          placeholder: '请输入价格计划ID',
        }] : []),
      ]
    }
  },
  computed:{
    tableColumns(){
      return this.columns&&this.columns.length>0?this.columns:this.getColumns()
    },
    tableSearchOptions(){
      return this.searchOptions&&this.searchOptions.length>0?this.searchOptions:this.localSearchOptions
    }
  },
  watch: {
    // 'productCategoryList':function () {
    //   const thirdOption = this.searchOptions[2]
    //   thirdOption.selectOptions=this.productCategoryList
    //   this.$set(this.searchOptions,2,thirdOption)
    // },
    // 'joinTypeList':function () {
    //   const thirdOption = this.searchOptions[3]
    //   thirdOption.selectOptions=this.joinTypeList
    //   this.$set(this.searchOptions,3,thirdOption)
    // },
    productCategoryList () {
      // 页面实际用的是 localSearchOptions（未传 searchOptions prop 时），不能再写 this.searchOptions
      const catalogOption = this.localSearchOptions.find(item => item.key === 'proCatalogId')
      if (!catalogOption) {
        return
      }
      catalogOption.selectOptions = this.productCategoryList
      this.localSearchOptions = [...this.localSearchOptions]
    }
  },
  mounted() {

  },
  methods: {
    loadDataList(params) {
      const requestParams = this.getRequestParams(params)
      requestParams.proJoinType = this.proJoinType
      return this.getHttpServices().getSourceService().post('zwy/combo/ComboSearch',requestParams)
    },
    getColumns(){
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px',
        },
        {
          title: this.idLabel,
          dataIndex: 'productNo',
          width: '100px',
        },
        {
          title: this.nameLabel,
          dataIndex: 'proName',
          width: '460px',
        },
        ...(this.showRateplanOtherId ? [{
          title: '价格计划ID',
          dataIndex: 'rateplanOtherId',
          width: '120px',
        }, {
          title: '价格计划名称',
          dataIndex: 'rateplanName',
          width: '260px',
        }] : []),
        {
          title: '商品分类',
          dataIndex: 'proCatalogId',
          width: '100px',
          scopedSlots: { customRender: 'proCatalogId' }
        },
        // 日历房（showRateplanOtherId=true）时使用 proJoinTypeName，否则proJoinType
        ...(this.showRateplanOtherId ? [{
          title: '自我游类目',
          dataIndex: 'proJoinTypeName',
          width: '110px',
        }] : [{
          title: '自我游类目',
          dataIndex: 'proJoinType',
          width: '110px',
          scopedSlots: { customRender: 'proJoinType' }
        }]),
        {
          title: '状态',
          dataIndex: 'proIsShield',
          width: '80px',
          align: 'center',
          scopedSlots: { customRender: 'proIsShield' }
        },
        {
          title: '来源',
          dataIndex: 'viewName',
          width: '200px',
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime',
          width: '160px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '230px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    operationRequest(url, proId,refresh=false) {
      this.requestGet(url,{proId:proId},()=>{
        if(refresh){
          this.$refs.table.refresh(false)
        }
      })
    },
    onSwitchStatus(item){
      const url='/zwy/combo/shield'
      this.operationRequest(url,item.proId,true)
    },

    onUpdateEvent(item){
      this.operationRequest(this.manualUpdateUrl, item.proId)
    },
    onTaskEvent(item){
      this.operationRequest(this.triggerScheduleUrl, item.proId)
    },
  }
}
</script>

<style scoped></style>
